import { render } from "./Destinations.vue?vue&type=template&id=30e95464"
import script from "./Destinations.vue?vue&type=script&lang=js"
export * from "./Destinations.vue?vue&type=script&lang=js"

import "./Destinations.vue?vue&type=style&index=0&id=30e95464&lang=css"
script.render = render

export default script